import { ChapterHeading } from "./ChapterHeading";
import { ProductCard } from "./ProductCard";
import { APP } from "../../constants/testIds";

export const MenuSection = ({ category, alt = false }) => {
  return (
    <section
      id={category.id}
      data-testid={APP.categorySection(category.id)}
      className={`relative scroll-mt-20 py-20 sm:py-28 md:py-32 ${
        alt ? "bg-[#0c0a07]" : "bg-[#0a0906]"
      }`}
    >
      {alt && (
        <div className="pointer-events-none absolute inset-0 opacity-[0.04] noise-texture" />
      )}
      <div className="relative mx-auto w-full max-w-4xl px-5 sm:px-8">
        <ChapterHeading
          number={category.number}
          title={category.title}
          subtitle={category.subtitle}
        />
        <div className="mt-6 sm:mt-10">
          {category.items.map((item, i) => (
            <ProductCard key={item.id} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
